import React from "react";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import HeaderGnb from "./HeaderGnb";
import HeaderLogo from "./HeaderLogo";
import HeaderGnbMobile from "./HeaderGnbMobile";
import HeaderMenu from "./HeaderMenu";
import { checkTokenAction, logoutAction, setLoginInfoAction } from "../../../modules/su/userModule";
import {isMobileOnly,isIE} from 'react-device-detect'
// import { useCookies } from 'react-cookie';
import { getUserCartAction, clearUserCartAction } from "../../../modules/su/userCartModule";
import { resetItemStatus } from '../../../modules/es/esItemModule';
import {getCommonCookie, setCommonCookie} from '../../../lib/util/CommonFunctions';
import moment from 'moment';
import $ from 'jquery';

const HeaderBlock = styled.header`
    background-color: ${props => props.color || '#fff'};
    border-bottom: ${props => props.border || '1px solid #ececec'};
    z-index: 50;
    // display: ${props => props.display};
    display: ${props=>props.display==='none'?props.display:'flex'};/*JPKIM*/
    justify-content: space-between;
    //${isMobileOnly?'flex-direction:column;':''}; /*JPKIM*/
    max-width: 100vw;   /*JPKIM?*/
    padding:20px 0px;
    ${!isMobileOnly&&"min-width : 1236px"};
    ${isMobileOnly&&"padding: 0 4vw; align-items: center; height:60px"};
`;

const HeaderContentsBlock = styled.div`
width: 100%;
max-width: 1176px;
margin: 0 auto;
`;

const useScroll = () => {
    // state를 생성합니다.
    const [state, setState] = useState({
        x: 0,
        y: 0
    });
    // scroll의 값을 가져와 state를 갱신합니다.
    const onScroll = () => {
        setState({ y: window.scrollY, x: window.scrollX });
    };
    useEffect(() => {
        // scroll 이벤트를 만들어줍니다. 스크롤을 움직일때 마다
        // onScroll 함수가 실행됩니다.
        window.addEventListener("scroll", onScroll);

        // 컴포넌트가 지워질때 이벤트 삭제
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    return state;
};


const Header = ({ usePopUp = false }) => {

    const dispatch = useDispatch();

    const [bgColor, setBgColor] = useState('#fff');
    const [curScr, setCurScr] = useState(null);
    const [update, setUpdate] = useState(false);
    const [updateStatusLocal, setUpdateStatusLocal] = useState(false);
    const [alreadyShownGhost, setAlreadyShownGhost] = useState(false);
    // const [cookies, setCookies] = useCookies(['access_token']);

    // Redux Store에서 저장된 값을 가져옴
    const { curMenu, accessToken , cartProdList, updateStatus} = useSelector(
        ({ headerReducer, userReducer, userCartReducer }) => ({
            curMenu: headerReducer.curMenu,
            accessToken: userReducer.accessToken,
            cartProdList:userCartReducer.cartProdList,
            updateStatus: userCartReducer.updateStatus,
        })
    );

    const { y } = useScroll();
    const thisYear = moment().format("YYYY");
    const isHalloween = moment().isBetween(`${thisYear}-10-29 10:00:00`,`${thisYear}-11-01 23:59:59`, undefined, '[]');

    useEffect(()=>{
        if(isHalloween&&!getCommonCookie('halloween')) {
            setCommonCookie('halloween', 'shown', 6, 'h');
            if(window.location.pathname==="/"){
                //show ghost animation only on main page
                let sf = [];
                let stageManager= new window.StageManager(window.Snap("#svg"));
                stageManager.init();

                makeGhosts();

                function makeGhosts(){
                    stageManager.addGhost();
                    sf.push(window.setTimeout(() => makeGhosts(), Math.random() * 500));
                }
                window.setTimeout(()=>{
                    stageManager = null;
                    sf.forEach(o=>{
                        window.clearTimeout(o)
                    })
                    // document.getElementById("svg").style.transition = "visibility 0s 2s, opacity 2s linear";
                    // document.getElementById("svg").style.display = "none";
                    // document.getElementById("svg").setAttribute("style","width:0; transition:width 3s linear;")
                    // document.getElementById("svg").setAttribute("style","transition: opacity 1s ease-out;opacity: 0;height: 0;overflow: hidden;")
                    window.setTimeout(()=> {
                        // document.getElementById('svg').style.display = 'none';
                        // document.getElementById('svg').parentElement.style.display = "none";
                        document.getElementById('svg').setAttribute("style","display:none");
                        document.getElementById('svg-container').setAttribute("style","display:none");
                    },1500)
                },2500)
            } else {
                // document.getElementById('svg').style.display = 'none';
                // document.getElementById('svg').parentElement.style.display = "none";
                document.getElementById('svg').setAttribute("style","display:none");
                document.getElementById('svg-container').setAttribute("style","display:none");
            }
        } else {
            // document.getElementById('svg').style.display = 'none';
            // document.getElementById('svg').parentElement.style.display = "none";
            document.getElementById('svg').setAttribute("style","display:none");
            document.getElementById('svg-container').setAttribute("style","display:none");
        }
    },[])


    useEffect(() => {

        if (y > 100) {
            setBgColor('#fff');
        } else {

            if (curMenu === 'es') {
                setBgColor(isMobileOnly?"#fff":'#fff');
            } else {
                setBgColor('#fff');
            }

        }
    }, [y])

    useEffect(() => {

        if (curScr !== curMenu) {
            // 여기서 Token Check
            if (accessToken !== null && curMenu !== 'login') {
                dispatch(checkTokenAction());
            }
            setCurScr(curMenu);
        }
    }, [curMenu])

    useEffect(() => {
        const changeStorage = () => {
            /* if(accessToken){
                let item = JSON.parse(localStorage.getItem('persist:root'));
                let token = localStorage.getItem('token');
                if(item !== null && item !== 'null' && token !== null && token !== 'null'){

                    let reducer = JSON.parse(item.userCartReducer);

                    if(cartProdList.length !== reducer.cartProdList.length){
                        /* dispatch(clearUserCartAction());
                        dispatch(getUserCartAction());
                        window.location.reload();
                    }
                }

                if(token === null || token === 'null'){
                    dispatch(logoutAction());
                    dispatch(clearUserCartAction());
                    dispatch(resetItemStatus());
                }
            }
            else{
                let token = localStorage.getItem('token');

                if(token !== null && token !== 'null'){
                    let item = JSON.parse(localStorage.getItem('persist:root'));
                    let reducer = JSON.parse(item.userReducer);
                    if(reducer.id !== null && reducer.id  !== 'null'){
                        dispatch(setLoginInfoAction(reducer));
                        dispatch(getUserCartAction());
                    }

                }
            } */

            let item = JSON.parse(localStorage.getItem('persist:root'));
            let token = localStorage.getItem('token');
            if(item !== null && item !== 'null'){

                let reducer = JSON.parse(item.userCartReducer);
                setUpdate(true);
            }

        }
        setUpdateStatusLocal(updateStatus);
        window.addEventListener("storage", changeStorage);
        return () => window.removeEventListener("storage", changeStorage);

        
    }, []);

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const onScroll = () => {
        if(!isMobileOnly) {
            $('.header').css({left: 0 - $(window).scrollLeft()});
        }
    };

    useEffect(() => {
        const changeStorage2 = () => {
            if(accessToken){
                let item = JSON.parse(localStorage.getItem('persist:root'));
                let token = localStorage.getItem('token');

                if(token === null || token === 'null'){
                    dispatch(logoutAction());
                    dispatch(clearUserCartAction());
                    dispatch(resetItemStatus());
                }
            }
            else{
                let token = localStorage.getItem('token');

                if(token !== null && token !== 'null'){
                    let item = JSON.parse(localStorage.getItem('persist:root'));
                    let reducer = JSON.parse(item.userReducer);
                    if(reducer.id !== null && reducer.id  !== 'null'){
                        dispatch(setLoginInfoAction(reducer));
                        dispatch(getUserCartAction());
                    }

                }
            }
        }
        window.addEventListener("storage", changeStorage2);
        return () => window.removeEventListener("storage", changeStorage2);
    }, [accessToken ]);

    useEffect(() => {

        if (update) {
            setUpdate(false);
            let item = JSON.parse(localStorage.getItem('persist:root'));
            let token = localStorage.getItem('token');
            if(item !== null && item !== 'null'){

                let reducer = JSON.parse(item.userCartReducer);
                if(cartProdList.length !== reducer.cartProdList.length){
                    if(updateStatusLocal !== updateStatus){
                        setUpdateStatusLocal(updateStatus)
                    }else{
                        if(isIE) {
                            return;
                        }
                        window.location.reload();
                    }

                }
            }
        }
    }, [update, updateStatus])

    // GNB 가져오기
    const getHeaderGnb = () => {
        // if (curMenu === 'main') {
        //     return <HeaderGnbMain />;
        // } else {
        //     return <HeaderGnb />;
        // }

        // Main Gnb 에서도 동일한 Header를 표시 하도록 요청 ( 2020/08/27 - 18시 개발 회의 )
        // 레이아웃때문에 Mobile 화면에서는 기존대로 GnbMain을 표시 (2020/08/28 JP) - 대신 검색창은 열린상태를 디폴트로
        // 모바일용 별도 헤더 제작 ㅓㅖ (0907)
        return isMobileOnly?<HeaderGnbMobile/>:<HeaderGnb />;

    }

    const pathcheck= window.location.pathname === "/st";

    return (isMobileOnly?
        <HeaderBlock className="header" color={bgColor} display={usePopUp ? 'none' : 'block'}
            border={bgColor === '#fff' ? '1px solid #ececec' : '0px solid #ececec'}>
            <HeaderLogo text="어디가구" link="/" type={isMobileOnly?'img':'background-img'}/>
            {getHeaderGnb()}
            {isMobileOnly&&<HeaderMenu />}
            <div id="svg-container" style={{position:"absolute",top:"0",left:"0", width:"100%", height:"100%", zIndex:pathcheck?"-1":"0", overflow: pathcheck?"hidden":"unset"}}>
                <svg id="svg" style={{position:"relative", zIndex:"0"}}/>
            </div>
        </HeaderBlock>
        :
        <HeaderBlock className="header" color={bgColor} display={usePopUp ? 'none' : 'block'}
            border={bgColor === '#fff' ? '1px solid #ececec' : '0px solid #ececec'}>
            <HeaderContentsBlock>
            <HeaderLogo text="어디가구" link="/" type={isMobileOnly?'img':'background-img'}/>
            {getHeaderGnb()}
            {isMobileOnly&&<HeaderMenu />}
            <div id="svg-container" style={{position:"absolute",top:"0",left:"0", width:"100%", height:"100%", zIndex:pathcheck?"-1":"0", overflow: pathcheck?"hidden":"unset"}}>
                <svg id="svg" style={{position:"relative", zIndex:"0"}}/>
            </div>
            </HeaderContentsBlock>
        </HeaderBlock>
    );
};

export default Header;
